export const CONFIRM_ACTION_DELETE = 'RCE_EDITOR/CONFIRM_DELETE_SELECTIONS';
export const CONFIRM_ACTION_DELETE_SECTION = 'RCE_EDITOR/CONFIRM_DELETE_SECTION';
export const MOVE_SELECTIONS = 'RCE_EDITOR/MOVE_SELECTIONS';
export const CONFIRM_COMMENT_DELETE = "RCE_EDITOR/CONFIRM_COMMENT_DELETE";
export const UPLOAD_STATUS = 'RCE_EDITOR/UPLOAD_STATUS';
